import { stop } from './stop';
import { create } from './create';

export const scenes = {
    stop,
    create,
};
